import React from 'react'
import { FooterNewLP } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { NewLPScreen } from '../screens/new-lp'

const LoanPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	NewLPScreen({
		ratePoints: [
			'Ставка от 14,9% годовых',
			'Без подтверждения дохода',
			'Одобрение за 30 минут',
			'Никаких брокерских комиссий',
			'Без поручителей',
			'Все расходы по сделке — на нас',
		],
		mainBlockPath: {
			subtitle: 'Займы от 500 тысяч рублей',
		},
		minLoan: 5e5,
	})

LoanPage.layout = PageLayout
LoanPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterNewLP />,
}

LoanPage.headProps = {
	canonicalLink: 'https://credit.club',
	title: pagesTitles[PagesPath.rp].title,
	description:
		'От 500 тысяч рублей ► Конкурентная ставка ► До 2 млн в день обращения ► Без скрытых комиссий и платежей',
	ogImageName: 'graph-loan.jpg',
}

export default LoanPage
